// import Layout from '@/page/layout/home'
import LayoutNoFooter from '@/page/layout/index'

/**
 * meta.scene：
 * 1:班级放学操作屏
 * 2:班级放学显示屏
 * 4:滞留生家长签到显示屏（滞留室学生看）
 * 5:滞留生显示屏（家长看）
 * 6:家长签到显示屏（学生看）
 *
 */
export default [
    {
        path: '/big-screen',
        name: 'bigScreen',
        component: LayoutNoFooter,
        children: [
            {
                path: 's1',
                name: 'big-screen-s1',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/big-screen/s1-leave-school-opt'),
                props: route => ({
                    isOpt: true//可以操作的标识
                }),
                meta: {
                    title: '班级放学操作屏',
                    isAuth: false,
                    scene:1
                }
            },
            {
                path: 's2',
                name: 'big-screen-s2',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/big-screen/s2-leave-school-view'),
                meta: {
                    title: '班级放学显示屏',
                    isAuth: false,
                    scene:2
                }
            },
            {
                path: 's4',
                name: 'big-screen-s4',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/big-screen/s4-parent-sign-stranded'),
                meta: {
                    title: '滞留学生家长签到显示屏',
                    isAuth: false,
                    scene:4
                }
            },
            {
                path: 's5',
                name: 'big-screen-s5',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/big-screen/s5-stranded-students'),
                meta: {
                    title: '滞留学生显示屏',
                    isAuth: false,
                    scene:5
                }
            },
            {
                path: 's6',
                name: 'big-screen-s6',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/big-screen/s6-parent-sign-normal'),
                meta: {
                    title: '家长签到显示屏',
                    isAuth: false,
                    scene:6
                }
            },
            {
                path: 's7',
                name: 'big-screen-s7',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/big-screen/s7-signage-text'),
                meta: {
                    title: '指示牌显示屏',
                    isAuth: false,
                    scene:7
                }
            },
            {
                path: 's8',
                name: 'big-screen-s7',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/big-screen/s8-go-leave-view.vue'),
                meta: {
                    title: '考勤数据看板',
                    isAuth: false,
                    scene:8
                }
            },
        ]
    },
]
